import { app_text_children } from "dependencies/userPortraits/index.js"

export default {
  name: "超星头像",
  id: "",
  type: "cxUserPortraits",
  children: app_text_children
}
